import type { Citation } from '@/features/documents/types';

const firstNumber = (...values: unknown[]) => {
  for (const value of values) {
    if (value === undefined || value === null) continue;
    const parsed = typeof value === 'string' ? Number.parseInt(value, 10) : Number(value);
    if (!Number.isNaN(parsed)) return parsed;
  }
  return -1;
};
export const citationFromEvent = (payload: Record<string, any>): Citation => {
  const pageStart = firstNumber(payload.pageStart, payload.page_start, payload.chunk_page_start);
  const page = firstNumber(payload.page);

  return {
    title: payload.title ?? payload.documentTitle ?? '',
    content: payload.content ?? payload.source ?? '',
    chunkId: payload.chunkId ?? payload.chunk_id ?? '',
    filepath: payload.filepath ?? payload.file_path ?? '',
    postfix: 0,
    order: 0,
    url:
      payload.url ??
      payload.documentId ??
      payload.document_id ??
      payload.docId ??
      payload.doc_id ??
      '',
    pageStart: pageStart > 0 ? pageStart : page >= 0 ? page + 1 : -1,
    pageEnd: firstNumber(payload.pageEnd, payload.page_end, payload.chunk_page_end),
    documentCategory: payload.documentCategory ?? payload.document_category ?? null,
  };
};
